import { useLocation } from 'react-router-dom';

/**
 * PageTransition
 *
 * Wraps page content with a fade-up animation on route change.
 * Uses the current pathname as a key to trigger re-animation.
 */
export default function PageTransition({ children }) {
  const location = useLocation();

  return (
    <div
      key={location.pathname}
      className="animate-page-enter"
    >
      {children}
    </div>
  );
}
